import React from 'react';
import { Divider } from 'antd';
import { FormattedMessage } from 'react-intl';
import CategoryDropdown from 'Components/CategoryDropdown/CategoryDropdown';

interface IProps {
  seat: Julius.Website.OrderSeatViewModel;
  discounts: Julius.Website.PriceDiscountViewModel[];
  onDiscountChange: (newSeat: Julius.Website.OrderSeatViewModel) => void;
  showSeatNumber: boolean;
}

const SelectedSeat: React.SFC<IProps> = ({
  seat,
  seat: {
    seatID,
    rowNbr,
    seatNbr,
    sectionName,
    discountID,
  },
  discounts,
  onDiscountChange,
  showSeatNumber,
}) => {

  const onDiscountSelect = (id: number) => {
    onDiscountChange({ ...seat, discountID: id });
  };

  const seatItem = {
    id: seat.discountID,
    name: seat.discountName,
    price: seat.reducedPrice,
  }
  var discountCategories;
       discounts.length === 1 ? discountCategories = [seatItem] : discountCategories = discounts

  return (
    <>
      <Divider />
      <div className='selected-seat'>
        { showSeatNumber &&
          <div className='seat'>
            <FormattedMessage 
              id='order.tickets.seat'
              defaultMessage=''
              values={ { rowNbr, seatNbr  } }
            />
          </div>
        }
        <div className='section'>
          { sectionName }
        </div>

        <CategoryDropdown 
          categories={ discountCategories }
          selectedCategoryID={ discountID }
          onSelect={ onDiscountSelect }
        />
      </div>
    </>
  );
};

export default SelectedSeat;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/SelectedSeatsList/SelectedSeat.tsx